module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/th_hokkaido-2a92c1004ad7ef59a193fbb183f5ee07.jpg";